import { textColor } from '@circlefin/tailwind/extend/colors.text'
import {
  CardNumberElement as StripeNumber,
  CardCvcElement as StripeCvc,
  CardExpiryElement as StripeExpiry,
} from '@stripe/react-stripe-js'

import { ElementWrapper } from '../ElementWrapper'

import type { ElementBaseProps } from '../ElementWrapper'
import type {
  StripeElementStyle,
  StripeElementClasses,
} from '@stripe/stripe-js'

export const baseElementClasses: StripeElementClasses = {
  base: 'p-3 border rounded-sm border-neutral font-circular',
  invalid: 'text-error border-error focus:focus-ring-error-inset',
}

export const baseElementStyles: StripeElementStyle = {
  base: {
    fontSize: '16px',
    fontWeight: 400,
    '::placeholder': {
      color: textColor.neutral.subtlest,
      fontWeight: 300,
    },
  },
  invalid: {
    color: textColor.error,
  },
}

export const CardNumberElement = (props: ElementBaseProps) => (
  <ElementWrapper {...props}>
    <StripeNumber
      options={{
        classes: baseElementClasses,
        style: baseElementStyles,
        preferredNetwork: ['visa', 'mastercard'],
        showIcon: true,
        iconStyle: 'solid',
        placeholder: '1234 1234 1234 1234',
      }}
    />
  </ElementWrapper>
)

export const CardExpiryElement = (props: ElementBaseProps) => (
  <ElementWrapper {...props}>
    <StripeExpiry
      options={{
        classes: baseElementClasses,
        style: baseElementStyles,
      }}
    />
  </ElementWrapper>
)

export const CardCvcElement = (props: ElementBaseProps) => (
  <ElementWrapper {...props}>
    <StripeCvc
      options={{
        classes: baseElementClasses,
        style: baseElementStyles,
      }}
    />
  </ElementWrapper>
)
